// export const BaseURL = 'https://api.themenuz.info';
export const BaseURL = 'https://api.themenuz.com';

// export const BaseURL = 'http://localhost:3000';

// export const websiteDomain = 'https://themenuz.info/#/';
export const websiteDomain = 'https://order.themenuz.com/#/';

export const iframeRoute = 'restaurant/';
export const deeplinkRoute = 'menu-items/';

export const vaySettings = {
  info: {
    defaultLang: 'en',
    name: 'The Menuz',
    logo: './assets/images/logo.png',
    loginLogo: './assets/images/logo.png',
    defaultRouter: '/dashboard/profile/profile',
    deeplinkRouter: 'menuz://',
    signup: false,
    multiTheme: false,
    multiLang: true,
    loginUser: false,
  },
  langs: ['EN', 'AR', 'FR'],
  pickerLang: {
    en: {
      lang: {
        locale: 'en_US',
        placeholder: 'Select date',
        rangePlaceholder: ['Start date', 'End date'],
        today: 'Today',
        now: 'Now',
        backToToday: 'Back to today',
        ok: 'Ok',
        clear: 'Clear',
        month: 'Month',
        year: 'Year',
        timeSelect: 'Select time',
        dateSelect: 'Select date',
        monthSelect: 'Choose a month',
        yearSelect: 'Choose a year',
        decadeSelect: 'Choose a decade',
        yearFormat: 'YYYY',
        dateFormat: 'M/D/YYYY',
        dayFormat: 'D',
        dateTimeFormat: 'M/D/YYYY HH:mm:ss',
        monthFormat: 'MMMM',
        monthBeforeYear: true,
        previousMonth: 'Previous month (PageUp)',
        nextMonth: 'Next month (PageDown)',
        previousYear: 'Last year (Control + left)',
        nextYear: 'Next year (Control + right)',
        previousDecade: 'Last decade',
        nextDecade: 'Next decade',
        previousCentury: 'Last century',
        nextCentury: 'Next century',
      },
      timePickerLocale: {
        placeholder: 'Select time',
      },
      dateFormat: 'YYYY-MM-DD',
      dateTimeFormat: 'YYYY-MM-DD HH:mm:ss',
      weekFormat: 'YYYY-wo',
      monthFormat: 'YYYY-MM',
    },
    ar: {
      lang: {
        locale: 'ar_EG',
        placeholder: 'حدد تاريخ',
        rangePlaceholder: ['Start date', 'End date'],
        today: 'اليوم',
        now: 'Now',
        backToToday: 'Back to today',
        ok: 'Ok',
        clear: 'Clear',
        month: 'Month',
        year: 'Year',
        timeSelect: 'Select time',
        dateSelect: 'Select date',
        monthSelect: 'Choose a month',
        yearSelect: 'Choose a year',
        decadeSelect: 'Choose a decade',
        yearFormat: 'YYYY',
        dateFormat: 'M/D/YYYY',
        dayFormat: 'D',
        dateTimeFormat: 'M/D/YYYY HH:mm:ss',
        monthFormat: 'MMMM',
        monthBeforeYear: true,
        previousMonth: 'Previous month (PageUp)',
        nextMonth: 'Next month (PageDown)',
        previousYear: 'Last year (Control + left)',
        nextYear: 'Next year (Control + right)',
        previousDecade: 'Last decade',
        nextDecade: 'Next decade',
        previousCentury: 'Last century',
        nextCentury: 'Next century',
      },
      timePickerLocale: {
        placeholder: 'Select time',
      },
      dateFormat: 'YYYY-MM-DD',
      dateTimeFormat: 'YYYY-MM-DD HH:mm:ss',
      weekFormat: 'YYYY-wo',
      monthFormat: 'YYYY-MM',
    },
  },
};
export const VayEditorSettings = {
  placeholder: '',

  // lang settings
  language: 'en',
  direction: 'ltr',

  // styles settings
  height: 500,
  heightMax: 500,
  heightMin: 500,
  width: 'auto',
  style: {
    font: '12px Arial',
  },

  //image setings
  image: {
    openOnDblClick: true,
    editSrc: true,
    useImageEditor: true,
    editTitle: true,
    editAlt: true,
    editLink: true,
    editSize: true,
    editBorderRadius: true,
    editMargins: true,
    editClass: true,
    editStyle: true,
    editId: true,
    editAlign: true,
    showPreview: true,
    selectImageAfterClose: true,
  },
  imageeditor: {
    min_width: 20,
    min_height: 20,
    closeAfterSave: false,
    width: '85%',
    height: '85%',
    crop: true,
    resize: true,
    resizeUseRatio: true,
    resizeMinWidth: 20,
    resizeMinHeight: 20,
    cropUseRatio: true,
    cropDefaultWidth: '70%',
    cropDefaultHeight: '70%',
  },

  // general settings
  uploader: {
    url: 'https://www.google.com/jodit/connector/index.php?action=fileUpload',
    insertImageAsBase64URI: false,
    imagesExtensions: ['jpg', 'png', 'jpeg', 'gif'],
  },
  disabled: false,
  toolbar: true,
  saveHeightInStorage: false,
  showPlaceholder: true,
  showTooltip: true,
  showTooltipDelay: 300, //ms
  showWordsCounter: true,
  addNewLineOnDBLClick: false,
  showMessageErrors: true,
  buttons: [
    'source',
    '|',
    'bold',
    'strikethrough',
    'underline',
    'italic',
    'eraser',
    '|',
    'superscript',
    'subscript',
    '|',
    'ul',
    'ol',
    '|',
    'outdent',
    'indent',
    '|',
    'font',
    'fontsize',
    'brush',
    'paragraph',
    '|',
    'image',
    'file',
    'video',
    'table',
    'link',
    '|',
    'align',
    'undo',
    'redo',
    '\n',
    'selectall',
    'cut',
    'copy',
    'paste',
    'copyformat',
    '|',
    'hr',
    'symbol',
    'fullsize',
    'print',
    'about',
  ],
  shortcutsEnabled: [
    'show',
    'bold',
    'italic',
    'underline',
    'strikeThrough',
    'indent',
    'outdent',
    'undo',
    'redo',
    'insertImage',
    'createLink',
  ],
};
